import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/BookcoverFill.tsx
const BookcoverFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 3a4 4 0 0 0-4 4v11a3 3 0 0 0 3 3h12a1 1 0 1 0 0-2v-2.268A2 2 0 0 0 20 15V5a2 2 0 0 0-2-2H8Zm9 14H7.5a1 1 0 1 0 0 2H17v-2ZM8.4 7a.9.9 0 1 0 0 1.8h6.2a.9.9 0 1 0 0-1.8H8.4Zm-.9 3.9a.9.9 0 0 1 .9-.9h3.2a.9.9 0 1 1 0 1.8H8.4a.9.9 0 0 1-.9-.9Z",
		fill: props.fill || "currentColor"
	})
}));
//#endregion
export { BookcoverFillIcon };
